const GLOBAL_PRODUCT_COLLECTION = 'globalProductCollection';
const GLOBAL_PRODUCTS = 'globalProducts';
const UNKNOWN_INVENTORY_MAX = 10;

module.exports = {
  GLOBAL_PRODUCT_COLLECTION,
  GLOBAL_PRODUCTS,
  UNKNOWN_INVENTORY_MAX,
};
